import axios from "axios";
// import router from "../router"
import Vue from 'vue'
Vue.prototype.axios = axios

// axios.interceptors.request.use(config=>{
//   if (window.sessionStorage.getItem('tokenStr')) {
// //请求携带自定义token
//     config.headers['X-TALENT-KEY'] =
//       window.sessionStorage.getItem('tokenStr');
//   }
//   return config
// },error => {
//   console.log(error);
// })

let base = '';

//传送json格式的post请求
export const postRequest = (url, data,headers) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data:data,
    headers:headers
    // headers: {'Content-Type': 'multipart/form-data'},
  //   paramsSerializer: function(params) {
  //     return qs.stringify(params, {arrayFormat: 'repeat'})
  // }
  })

}

export const postFile = (url, data) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data:data,
    headers: {
      'Content-Type': "multipart/form-data",
    },
    // processData: false, // 不处理数据
// contentType: false // 不设置内容类型

  })

}

//传递json的put请求
export const putRequest = (url, headers) => {
    return axios({
      method: 'put',
      url: `${base}${url}`,
      headers: headers
    })
  }
  //传递json的get请求
  export const getRequest = (url, headers) => {
    return axios({
      method: 'get',
      url: `${base}${url}`,
      headers: headers
    })
  }
  //传递json的delete请求
  export const deleteRequest = (url, params) => {
    return axios({
      method: 'delete',
      url: `${base}${url}`,
      data: params
    })
  }